module.exports = __webpack_public_path__ + "static/media/markerpin_pink.8ccdc7da.svg";